import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { createClient } from '@supabase/supabase-js';
import { onSupabaseAuthStateChanged } from './supabaseAuth';

export const SupabaseContext = createContext(null);

export let supabase = null;
let activeConfig = null;

export const getSupabaseConfig = () => ({
    url: typeof process !== 'undefined'
        ? process.env.REACT_APP_SUPABASE_URL || process.env.EXPO_PUBLIC_SUPABASE_URL || ''
        : '',
    anonKey: typeof process !== 'undefined'
        ? process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || ''
        : '',
});

export const createSupabaseClient = ({ url, anonKey, storage }) => {
    if (!url || !anonKey) {
        supabase = null;
        activeConfig = null;
        return null;
    }

    if (supabase && activeConfig?.url === url && activeConfig?.anonKey === anonKey && activeConfig?.storage === storage) {
        return supabase;
    }

    activeConfig = { url, anonKey, storage };
    supabase = createClient(url, anonKey, {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: typeof document !== 'undefined',
            ...(storage ? { storage } : {}),
        },
    });

    return supabase;
};

export const SupabaseProvider = ({ children, storage }) => {
    const { url, anonKey } = getSupabaseConfig();
    const client = useMemo(
        () => createSupabaseClient({ url, anonKey, storage }),
        [url, anonKey, storage]
    );

    useEffect(() => onSupabaseAuthStateChanged(() => {}), [client]);

    return (
        <SupabaseContext.Provider value={client}>
            {children}
        </SupabaseContext.Provider>
    );
};

export const useSupabase = () => {
    const client = useContext(SupabaseContext);
    if (!client) {
        throw new Error('Supabase is not configured. Set the platform Supabase URL and anon key.');
    }
    return client;
};
